import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Card, CardContent, Grid, Typography,
} from '@mui/material';
import {
  CommandPanels,
  // EditorControls,
  withBaseEditor,
} from '../../BaseEditor';
// import { dateFormat } from '../../../api/utils';

function EditorRenderer({
  getControl, currentUser,
  // fields, data, dataSetter,
}) {
  return (
    <Grid container spacing={2}>
      {currentUser.is_superuser && (
        <Grid item sm={6}>
          {getControl('org', {
            backend: '/api/catalog/orgs/',
            label: 'Установа',
          })}
        </Grid>
      )}

      <Grid item sm={6}>
        {getControl('locality')}
      </Grid>

      <Grid item sm={12}>
        <Card>
          <CardContent>
            <Grid container justifyContent="left" spacing={2}>
              <Grid item sm={3}>
                {getControl('datefrom')}
              </Grid>

              <Grid item sm={3}>
                {getControl('dateto')}
              </Grid>

              <Grid item sm={6}>
                {getControl('ref')}
              </Grid>

            </Grid>
          </CardContent>
        </Card>
      </Grid>

      <Grid item sm={6}>
        <Card>
          <CardContent>
            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
              <Typography variant="h6" component="div">
                Земельні ділянки в оренді
              </Typography>
            </Box>

            <Grid container justifyContent="space-between" spacing={2}>
              <Grid item sm={6}>
                <Typography align="center" color="info" variant="subtitle1">
                  Нормативно грошова оцінка проведена
                </Typography>
              </Grid>

              <Grid item sm={6}>
                <Typography align="center" color="info" variant="subtitle1">
                  Ділянки за межами населених пунктів. Нормативно грошова оцінка не проведено
                </Typography>
              </Grid>

              <Grid item sm={3} justifyContent="space-between">
                {getControl('law_person_value_1', { label: 'юр.особи' })}
              </Grid>
              <Grid item sm={3} justifyContent="space-between">
                {getControl('individual_value_1', { label: 'фіз.особи' })}
              </Grid>

              <Grid item sm={3} justifyContent="space-between">
                {getControl('law_person_value_2', { label: 'юр.особи' })}
              </Grid>
              <Grid item sm={3} justifyContent="space-between">
                {getControl('individual_value_2', { label: 'фіз.особи' })}
              </Grid>

            </Grid>

          </CardContent>
        </Card>
      </Grid>

      <Grid item sm={6}>
        <Card>
          <CardContent>
            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
              <Typography variant="h6" component="div">
                Земельні ділянки у власності
              </Typography>
            </Box>

            <Grid container justifyContent="space-between" spacing={2}>
              <Grid item sm={6}>
                <Typography align="center" color="info" variant="subtitle1">
                  Нормативно грошова оцінка проведена
                </Typography>
              </Grid>

              <Grid item sm={6}>
                <Typography align="center" color="info" variant="subtitle1">
                  Ділянки за межами населених пунктів. Нормативно грошова оцінка не проведено
                </Typography>
              </Grid>

              <Grid item sm={3} justifyContent="space-between">
                {getControl('law_person_value_3', { label: 'юр.особи' })}
              </Grid>
              <Grid item sm={3} justifyContent="space-between">
                {getControl('individual_value_3', { label: 'фіз.особи' })}
              </Grid>

              <Grid item sm={3} justifyContent="space-between">
                {getControl('law_person_value_4', { label: 'юр.особи' })}
              </Grid>
              <Grid item sm={3} justifyContent="space-between">
                {getControl('individual_value_4', { label: 'фіз.особи' })}
              </Grid>

            </Grid>

          </CardContent>
        </Card>
      </Grid>

    </Grid>
  );
}

EditorRenderer.propTypes = {
  getControl: PropTypes.func.isRequired,
  // dataSetter: PropTypes.func.isRequired,
  currentUser: PropTypes.shape({
    org: PropTypes.shape({
      id: PropTypes.number,
      repr: PropTypes.string,
      addr_prefix: PropTypes.string,
    }),
    is_superuser: PropTypes.bool,
  }).isRequired,
  fields: PropTypes.shape({
    notes: PropTypes.shape({
      label: PropTypes.string,
      required: PropTypes.bool,
      read_only: PropTypes.bool,
    }),
  }).isRequired,
  data: PropTypes.shape({
    notes: PropTypes.string,
  }).isRequired,
};

export default withBaseEditor(EditorRenderer, '/api/catalog/percentvalue/', CommandPanels.catCommandPanel);
